document.addEventListener("DOMContentLoaded", function(event) {
  let carouselContainer = document.querySelector('.product-gallery .product-gallery__carousel');
  if (carouselContainer !== null) {
    let carouselContainerHeight = carouselContainer.clientHeight - 24;
    document.querySelector('.product-gallery .product-gallery__thumbnail-list carousel-navigation').style.maxHeight = carouselContainerHeight + 'px';
    document.querySelector('.product-gallery .product-gallery__thumbnail-list').style.opacity = '1';
  }

  function getNextSiblingBlock(element) {
  while ((element = element.nextSibling)) {
      if (element.style.display === '' && !element.hasAttribute('hidden')) {
        return element;
      }
    }
    return null;
  }

  const thumbnailMobileControlNext = document.getElementById('thumbnail-control-next');
  if (thumbnailMobileControlNext !== null) {
    thumbnailMobileControlNext.addEventListener('click', function() {
      const element = document.querySelector('carousel-navigation button[aria-current="true"]');
      const nextSibling = getNextSiblingBlock(element);
      
      if (nextSibling) {
        let mediaId = nextSibling.getAttribute('aria-label');
        if (mediaId !== null) {
          document.querySelector('button[aria-label="'+ mediaId +'"]').click();
        }
      }
    });
  }

  const ingredientLinks = document.querySelectorAll('.ingredient--used-in a'); 
  if (ingredientLinks !== null){
    ingredientLinks.forEach(link => {
      link.addEventListener('click', function(event) {
        window.location.href = link.href
      });
    });
  }

  const fixedBackgroundVideos = document.querySelectorAll('.text-with-fixed-background .content-box__background-media video-media'); 
  if (fixedBackgroundVideos !== null){
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setTimeout(function(){
            entry.target.style.position = 'fixed';
          }, 100);
        }
      });
    });
    fixedBackgroundVideos.forEach(element => {
      observer.observe(element);
    });
  }
});

window.addEventListener('resize', function() {
  let carouselContainer = document.querySelector('.product-gallery .product-gallery__carousel');
  if (carouselContainer !== null) {
    let carouselContainerHeight = carouselContainer.clientHeight - 24;
    document.querySelector('.product-gallery .product-gallery__thumbnail-list carousel-navigation').style.maxHeight = carouselContainerHeight + 'px';
  }
});